module.exports = __webpack_public_path__ + "img/eagleEye2_3.02fedafd.png";